




















/*interface ISignUser {
    create_date: null | number,
    name: string,
    userName: string, 
    user_id: string
}*/

import { Component, Vue, Prop } from 'vue-property-decorator';
import { getBudgetText }  from '@/modules/budget-request/components/budget-sum-calc/js/budget-translation';

@Component({
    name: 'c-sign-modal'
})
export default class CBudgetUserSignModal extends Vue {
    private showModal = false;
    private signUserLst: any[] = [];
    private curUserId: string | null = null; // текущий пользователь - для подсказки про отзыв

    private showEvent(signUserLst: any[], curUserId: string | null = null) {
        this.signUserLst = signUserLst;
        this.curUserId = curUserId;
        this.showModal = true;
    }

    /**
     * подсказка нужна, когда у текущего пользователя одновременно есть подписанная
     * и неподписанная должность: кнопки «Подписать» уже нет, а статус «Частично подписан»
     */
    private get showAddPostHint(): boolean {
        if (!this.curUserId) { return false; }
        const myLst = this.signUserLst.filter((el) => el.user_id === this.curUserId);
        return myLst.some((el) => el.create_date) && myLst.some((el) => !el.create_date);
    }

    /**
     * название должности по текущему языку: считаем в шаблоне, а не при загрузке подписантов -
     * иначе при смене языка без перезагрузки страницы в модалке остаётся язык момента загрузки.
     * Прочерк - для исторических подписей по должности, которой нет в справочнике
     */
    private positionText(signUsr: any): string {
        const pos = signUsr.position;
        if (!pos) { return '—'; }
        return pos[`name_${this.$i18n.locale}`] || pos.name_ru || pos.name_kk || '—';
    }

    /**
     * ФИО подписанта по текущему языку: на kk-локали - name_kk, при его отсутствии - name (ru)
     */
    private nameText(signUsr: any): string {
        if (this.$i18n.locale === 'kk') { return signUsr.name_kk || signUsr.name; }
        return signUsr.name;
    }

    // ---- переводы
    private getBudgetText(link: string) {  return getBudgetText(link); }

    private get allTitle() {
        const obj = {
            title: this.getBudgetText('user_sign_modal.title'), // Статус подписания
            signed: this.getBudgetText('user_sign_modal.signed'), // Подписано
            not_signed: this.getBudgetText('user_sign_modal.not_signed'), // Не подписано
            // Чтобы подписать добавленную должность, отзовите свою подпись и подпишите заново
            signAddPostHint: this.getBudgetText('user_sign_modal.signAddPostHint'),
        };
        return obj;
    }
}
